(() => {
  const root = document.documentElement;
  const main = document.querySelector('#MainContent');
  if (!(main instanceof HTMLElement) || root.dataset.daoBlackGoldReady === 'true') return;
  if (main.dataset.template === 'index') return;

  root.dataset.daoBlackGoldReady = 'true';
  root.classList.add('dao-black-gold-ready');

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealSelectors = [
    '.dao-collection-hero__inner > *',
    'product-card',
    '.product-information__media',
    '.product-details > .group-block',
    '.dao-policy-page__intro',
    '.dao-policy-page__grid > div',
    '.dao-contact-page .contact-form',
    '.dao-notes-page .blog-post-item'
  ];

  const revealItems = [...main.querySelectorAll(revealSelectors.join(','))]
    .filter((item, index, list) => item instanceof HTMLElement && list.indexOf(item) === index)
    .filter((item) => item.getBoundingClientRect().height > 0);

  root.dataset.daoBlackGoldAnimated = 'true';

  revealItems.forEach((item, index) => {
    item.classList.add('dao-black-gold-reveal');
    item.style.setProperty('--dao-reveal-delay', `${Math.min(index % 6, 5) * 60}ms`);
  });

  const showVisible = () => {
    revealItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.04 && rect.bottom > -80) {
        item.classList.add('dao-black-gold-in');
      }
    });
  };

  if (prefersReduced || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('dao-black-gold-in'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('dao-black-gold-in');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });

  revealItems.forEach((item) => observer.observe(item));
  window.requestAnimationFrame(showVisible);
  window.setTimeout(showVisible, 380);
})();
